import MenuIcon from "@mui/icons-material/Menu";
import SmartphoneIcon from "@mui/icons-material/Smartphone";
import { Box, IconButton, Stack, Tooltip } from "@mui/material";
import { graphql } from "babel-plugin-relay/macro";
import { useFragment } from "react-relay";
import { TopNavBar_user$key } from "./__generated__/TopNavBar_user.graphql";
import CurrentUser from "../auth/CurrentUser";

const userFragment = graphql`
  fragment TopNavBar_user on UserType {
    ...CurrentUser_userFragment
  }
`;

const TopNavBar = ({
  user: userKey,
  onDrawerOpen,
  onDrawerClose,
  showPreviewToggle = false,
  isPreviewOpen = false,
  onPreviewToggle,
}: {
  user: TopNavBar_user$key;
  onDrawerOpen: () => void;
  onDrawerClose: () => void;
  showPreviewToggle?: boolean;
  isPreviewOpen?: boolean;
  onPreviewToggle?: () => void;
}) => {
  const user = useFragment(userFragment, userKey);

  return (
    <Box
      sx={{
        width: "100%",
        px: 2,
        py: "12px",
        zIndex: 1100,
        flexShrink: 0,
        background: "white",
        boxShadow:
          "0px 1px 1px rgba(100, 116, 139, 0.06), 0px 1px 2px rgba(100, 116, 139, 0.1)",
      }}
    >
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        spacing={1}
        sx={{ width: "100%", minWidth: 0 }}
      >
        <IconButton
          color="inherit"
          aria-label="open drawer"
          edge="start"
          onClick={onDrawerOpen}
          sx={{ display: { md: "none" } }}
        >
          <MenuIcon />
        </IconButton>
        <Box sx={{ flexGrow: 1, minWidth: 0 }} />
        <Stack direction="row" spacing={1} alignItems="center">
          {showPreviewToggle && (
            <Tooltip title={isPreviewOpen ? "Hide preview" : "Show preview"}>
              <IconButton
                color={isPreviewOpen ? "primary" : "default"}
                aria-label={isPreviewOpen ? "Hide preview" : "Show preview"}
                aria-pressed={isPreviewOpen}
                onClick={onPreviewToggle}
                sx={{ display: { xs: "inline-flex", xl: "none" } }}
              >
                <SmartphoneIcon />
              </IconButton>
            </Tooltip>
          )}
          <CurrentUser user={user} onDrawerClose={onDrawerClose} />
        </Stack>
      </Stack>
    </Box>
  );
};

export default TopNavBar;
